import { useRef, useState, useEffect } from 'react';
import {
	faCheck,
	faTimes,
	faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import axios from './api/axios';

import './register.css'

//const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const USER_REGEX =  /^(?=.*[a-z])(?=.*[A-Z]).{4,24}$/;
//const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z]).{4,24}$/;

const REGISTER_URL = '/register';

const Register = () => {
    const userRef = useRef();
    const errRef = useRef();
    const [user, setUser] = useState("");
  const [language, setLanguage] = useState("NL");
    const [validName, setValidName] = useState(false);
    const [userFocus, setUserFocus] = useState(false);
    const [pwd, setPwd] = useState("");
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);
    const [matchPwd, setMatchPwd] = useState("");
    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const [success, setSuccess] = useState(false);

    // State events
    useEffect(() => {
        userRef.current.focus();
    }, []);
    
    useEffect(() => {
        setValidName(USER_REGEX.test(user));
    }, [user]);
    
    useEffect(() => {
        setValidPwd(PWD_REGEX.test(pwd));
        setValidMatch(pwd === matchPwd);
    }, [pwd, matchPwd]);
    
    useEffect(() => {
        setErrMsg("");
    }, [user, pwd, matchPwd]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        const v1 = USER_REGEX.test(user);
        const v2 = PWD_REGEX.test(pwd);
        if (!v1 || !v2) {
          setErrMsg("Ongeldig wachtwoord of gebruikersnaam");
          return;
        }
      
        try {
          const response = await axios.post(
            REGISTER_URL,
            JSON.stringify({ user, pwd, language }),
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            }
          );
          setSuccess(true);
          //clear state and controlled inputs
          setUser("");
          setPwd("");
          setMatchPwd("");
          setLanguage("NL");
        } catch (err) {
          if (!err?.response) {
            setErrMsg("No Server Response");
          } else if (err.response?.status === 409) {
            setErrMsg("Deze gebruikersnaam bestaat al");
          } else {
            setErrMsg("Registreren is mislukt");
          }
          errRef.current.focus();
        }
      };


    return (
      <div className="textColor">
        <section>
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>
          <h1>Registreer</h1>
          <form onSubmit={handleSubmit}>
            <label htmlFor="username">
              Gebruikersnaam:
              <FontAwesomeIcon
                icon={faCheck}
                className={validName ? "valid" : "hide"}
              />
              <FontAwesomeIcon
                icon={faTimes}
                className={
                  validName || !user ? "hide" : "invalid"
                }
              />
            </label>
            <input
              type="text"
              id="username"
              ref={userRef}
              autoComplete="off"
              onChange={(e) => setUser(e.target.value)}
              value={user}
              required
              aria-invalid={validName ? "false" : "true"}
              aria-describedby="uidnote"
              onFocus={() => setUserFocus(true)}
              onBlur={() => setUserFocus(false)}
            />
            <p
              id="uidnote"
              className={
                userFocus && user && !validName
                  ? "instructions"
                  : "offscreen"
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              De gebruikersnaam moet tussen de 4 en 24 letter bevatten.
            </p>
            <label htmlFor="password">
              Wachtwoord:
              <FontAwesomeIcon
                icon={faCheck}
                className={validPwd ? "valid" : "hide"}
              />
              <FontAwesomeIcon
                icon={faTimes}
                className={
                  validPwd || !pwd ? "hide" : "invalid"
                }
              />
            </label>
            <input
              type="password"
              id="password"
              onChange={(e) => setPwd(e.target.value)}
              value={pwd}
              required
              aria-invalid={validPwd ? "false" : "true"}
              aria-describedby="pwdnote"
              onFocus={() => setPwdFocus(true)}
              onBlur={() => setPwdFocus(false)}
            />
            <p
              id="pwdnote"
              className={
                pwdFocus && !validPwd
                  ? "instructions"
                  : "offscreen"
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              Het wachtwoord moet tussen de 4 en 24 letter bevatten en 1 hoofdletter hebben.
              
            </p>
            <label htmlFor="confirm_pwd">
              Bevestig wachtwoord:
              <FontAwesomeIcon
                icon={faCheck}
                className={
                  validMatch && matchPwd ? "valid" : "hide"
                }
              />
              <FontAwesomeIcon
                icon={faTimes}
                className={
                  validMatch || !matchPwd ? "hide" : "invalid"
                }
              />
            </label>
            <input
              type="password"
              id="confirm_pwd"
              onChange={(e) => setMatchPwd(e.target.value)}
              value={matchPwd}
              required
              aria-invalid={validMatch ? "false" : "true"}
              aria-describedby="confirmnote"
              onFocus={() => setMatchFocus(true)}
              onBlur={() => setMatchFocus(false)}
            />
            <p
              id="confirmnote"
              className={
                matchFocus && !validMatch
                  ? "instructions"
                  : "offscreen"
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              Moet identiek zijn aan eerste wachtwoord.
            </p>
            <label htmlFor="language">Taal:</label>
            <select
              id="language"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              required
            >
              <option value="NL">Nederlands</option>
              <option value="FR">Frans</option>
              <option value="EN">Engels</option>
            </select>
            <br></br>
            <button className='colorButton'
              disabled={
                !validName || !validPwd || !validMatch
                  ? true
                  : false
              }
            >
              Account aanmaken
            </button>
          </form>
          <p>
            Heeft u al een account?
            <br />
            <span className="line">
              {/*put router link here*/}
              {<a href="/login">Aanmelden</a>}
            </span>
          </p>
        </section>
      </div>
    );
  };
  
  export default Register;